import React from 'react';

import {
  Outlet
} from 'react-router-dom';

import {
  Header
} from './Header';

import {
  Sidebar
} from './Sidebar';

import {
  MobileBottomNav
} from './MobileBottomNav';


export const AppLayout:
React.FC = () => {

  return (

    <div
      className="
        kaizen-shell
        relative
        h-[100dvh]
        min-h-screen
        overflow-hidden
        flex flex-col
        text-slate-100
      "
    >

      {/* Ambient indigo field */}
      <div
        aria-hidden="true"
        className="
          pointer-events-none
          absolute
          -top-52
          left-[9%]
          w-[540px]
          h-[540px]
          rounded-full
          bg-indigo-500/[0.075]
          blur-[120px]
        "
      />


      <div
        aria-hidden="true"
        className="
          pointer-events-none
          absolute
          -bottom-64
          right-[-100px]
          w-[520px]
          h-[520px]
          rounded-full
          bg-sky-500/[0.025]
          blur-[130px]
        "
      />


      <Header />


      <div
        className="
          relative
          z-10
          flex-1
          flex
          min-h-0
          overflow-hidden
        "
      >

        <Sidebar />


        <main
          className="
            flex-1
            min-w-0
            overflow-y-auto
            overflow-x-hidden
            px-3
            pt-4
            pb-28
            sm:px-4
            md:px-6
            md:py-5
            md:pb-6
          "
        >

          <div
            className="
              w-full
              max-w-7xl
              mx-auto
              space-y-4
              md:space-y-6
            "
          >

            <Outlet />

          </div>

        </main>

      </div>


      <MobileBottomNav />

    </div>
  );
};
